import { Briefcase02 } from "Icons/Briefcase02";
import { LinkExternal02 } from "Icons/LinkExternal02";
import { Lock02Icon } from "Icons/Lock02";

import { useState } from "react";

import { css } from "@emotion/react";

import { Badge } from "components/shared/library/Badge";
import { Button } from "components/shared/library/Button";
import { ButtonLink } from "components/shared/library/ButtonLink";
import { Typography } from "components/shared/library/Typography";

import { useAccount } from "contexts/AccountContext";

import { Job, insertJobEventType, deleteJobEventType } from "apis/jobs";

import { uiGray, white } from "constants/colors";

const style = {
  wrapper: css({
    background: white,
    borderRadius: 16,
    padding: 24,
    display: "flex",
    flexDirection: "column",
    gap: 24,
  }),
  header: css({
    display: "flex",
    flexDirection: "column",
    gap: 8,
  }),
  description: css({
    display: "flex",
    gap: 8,
  }),
  hidden: css({ display: "hidden" }),
  applyBtn: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  btns: css({
    display: "flex",
    gap: 8,
  }),
};

type Props = {
  job: Job;
};

export const JobHeaderCard = ({ job }: Props) => {
  const { accountProfile } = useAccount(false);
  const [isJobSaved, setIsJobSaved] = useState(job.eventType === "save");
  return (
    <div css={style.wrapper}>
      <div css={style.header}>
        {job.title && (
          <Typography size="L" weight="bold">
            {job.title}
          </Typography>
        )}
        <div>
          {job.orgName && (
            <Typography color={uiGray[70]} weight="bold" size="XS">
              {job.orgName}
            </Typography>
          )}
          <Typography color={uiGray[40]} size="XS">
            {" · "}
          </Typography>
          {job.location && (
            <Typography color={uiGray[70]} size="XS">
              {job.location}
            </Typography>
          )}
          {job.location && job.modality && <Typography size="XS"> </Typography>}
        </div>
      </div>
      {job.modality && (
        <div css={style.description}>
          <Briefcase02 width={20} height={20} stroke={uiGray[70]} />
          <Badge
            color="blue"
            label={
              { remote: "Remote", hybrid: "Hybrid", "on-site": "On-site" }[
                job.modality
              ]
            }
          />
        </div>
      )}
      <div css={style.btns}>
        <ButtonLink
          sameTab={false}
          href={job.url}
          color="black"
          size="medium"
          IconRight={accountProfile?.id ? LinkExternal02 : Lock02Icon}
          customCss={{ button: style.applyBtn }}
          disabled={accountProfile?.id === undefined}
        >
          Apply
        </ButtonLink>

        {accountProfile?.id && (
          <Button
            background="outlined"
            color="black"
            size="medium"
            onClick={() => {
              isJobSaved
                ? deleteJobEventType(job.url, accountProfile.id, "save")
                : insertJobEventType(job.url, accountProfile.id, "save");
              setIsJobSaved(!isJobSaved);
            }}
          >
            {isJobSaved ? "Saved" : "Save"}
          </Button>
        )}
      </div>
    </div>
  );
};
